/**
 * @generated SignedSource<<1d109a6b1ed411b36823d174629ad844>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EmailTemplatesScreen_EmailTemplatesQuery$variables = Record<PropertyKey, never>;
export type EmailTemplatesScreen_EmailTemplatesQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"EmailTemplatesTable_EmailTemplatesListFragment">;
};
export type EmailTemplatesScreen_EmailTemplatesQuery = {
  response: EmailTemplatesScreen_EmailTemplatesQuery$data;
  variables: EmailTemplatesScreen_EmailTemplatesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subject",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EmailTemplatesScreen_EmailTemplatesQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "EmailTemplatesTable_EmailTemplatesListFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "EmailTemplatesScreen_EmailTemplatesQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminQueryType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "EmailAdminSchema",
            "kind": "LinkedField",
            "name": "Email",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PersonalizedEmailTemplatesConnection",
                "kind": "LinkedField",
                "name": "PersonalizedEmailTemplates",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPreviousPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startCursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PersonalizedEmailTemplatesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PersonalizedEmailTemplate",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "id",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "EmailTemplate",
                            "kind": "LinkedField",
                            "name": "template",
                            "plural": false,
                            "selections": [
                              (v0/*: any*/),
                              (v1/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "connection",
                "key": "EmailTemplatesTable_PersonalizedEmailTemplates",
                "kind": "LinkedHandle",
                "name": "PersonalizedEmailTemplates"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "EmailTemplate",
                "kind": "LinkedField",
                "name": "AvailableSystemTemplates",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "previewText",
                    "storageKey": null
                  },
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "body",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "variables",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a5ed4693b57fe61c865a5030320ab5ce",
    "id": null,
    "metadata": {},
    "name": "EmailTemplatesScreen_EmailTemplatesQuery",
    "operationKind": "query",
    "text": "query EmailTemplatesScreen_EmailTemplatesQuery {\n  ...EmailTemplatesTable_EmailTemplatesListFragment\n}\n\nfragment EmailTemplatesTable_EmailTemplatesListFragment on Query {\n  Admin {\n    Email {\n      PersonalizedEmailTemplates {\n        pageInfo {\n          endCursor\n          hasPreviousPage\n          hasNextPage\n          startCursor\n        }\n        edges {\n          node {\n            id\n            template {\n              key\n              subject\n            }\n            __typename\n          }\n          cursor\n        }\n      }\n    }\n  }\n  ...NewEmailTemplateButton_AvailableTemplatesFragment\n}\n\nfragment NewEmailTemplateButton_AvailableTemplatesFragment on Query {\n  Admin {\n    Email {\n      AvailableSystemTemplates {\n        key\n        previewText\n        subject\n        body\n        variables\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0ba03bced48691690511cf0d187a174d";

export default node;
